import React from "react";
import { Grid, Typography, TextField, Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

const ListOfPossibleCauses = (props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    return (
        <Grid container xs={6} sm={6} md={6}>
            <Box
                sx={{
                    width: "98%",
                    px: 1,
                    py: 1,
                    m: 1,
                    mt: 0,
                    alignItems: "center",
                    backgroundColor: theme.palette.grey[100],
                    borderRadius: "12px",
                    boxShadow: 3,
                    gap: 2
                }}
            >
                <Grid item xs={12} sm={12}>
                    <Typography variant="h6" align="center" sx={{ fontSize: 15, backgroundColor: "#DEE0E0" }}>
                        {t("ListOfPossibleCauses")}
                    </Typography>
                </Grid>

                <Grid container xs={12} sm={12} md={12} padding={1}>
                    {/*A*/}
                    <Grid container xs={12} sm={12} padding={1}>
                        <Grid item xs={1} sm={1} sx={{ display: "grid", alignContent: "center" }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                                A
                            </Typography>
                        </Grid>
                        <Grid item xs={11} sm={11}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                                <TextField
                                    size="small"
                                    type="primary"
                                    disabled={props.disableStates.isCauseADisable}
                                    value={props.causeA}
                                    onChange={props.handleCauseAChange}
                                    fullWidth
                                    error={props.hasCauseAError}
                                    helperText={props.causeAErrorText}
                                ></TextField>
                            </Typography>
                        </Grid>
                    </Grid>
                    {/*B*/}
                    <Grid container xs={12} sm={12} padding={1}>
                        <Grid item xs={1} sm={1} sx={{ display: "grid", alignContent: "center" }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                                B
                            </Typography>
                        </Grid>
                        <Grid item xs={11} sm={11}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                                <TextField
                                    size="small"
                                    type="primary"
                                    disabled={props.disableStates.isCauseBDisable}
                                    value={props.causeB}
                                    onChange={(event) => props.setCauseB(event.target.value)}
                                    fullWidth
                                ></TextField>
                            </Typography>
                        </Grid>
                    </Grid>
                    {/*C*/}
                    <Grid container xs={12} sm={12} padding={1}>
                        <Grid item xs={1} sm={1} sx={{ display: "grid", alignContent: "center" }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                                C
                            </Typography>
                        </Grid>
                        <Grid item xs={11} sm={11}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                                <TextField
                                    size="small"
                                    type="primary"
                                    disabled={props.disableStates.isCauseCDisable}
                                    value={props.causeC}
                                    onChange={(event) => props.setCauseC(event.target.value)}
                                    fullWidth
                                ></TextField>
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </Grid>
    );
};

export default ListOfPossibleCauses;
